import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';

import { Button, CircularProgress, Typography, useTheme } from '@mui/material';

import { trackClickButtonCredits } from '../../utils/analytics/analytics';
import { colors } from '../../utils/colors';
import { RootState } from '../../utils/store';
import { IconRocketLaunchFilled } from './icons';
import { GradientTypography } from './minicomponents';

export function RequestsCounter() {
  const credits = useSelector(
    (state: RootState) => state.appState.subcription?.credits
  );
  const isLoading = credits === undefined;

  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Button
      component={RouterLink}
      to="/app/profile/subscription"
      onClick={() => trackClickButtonCredits()}
      sx={{
        padding: theme.spacing(0, 2),
      }}
    >
      <IconRocketLaunchFilled
        sx={{
          mr: 1,
          background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        }}
      />
      <Typography sx={{ color: 'text.primary', fontWeight: 'bold' }}>
        {t('website.creditsLeftCounter.label')}
      </Typography>
      &nbsp;
      {isLoading ? (
        <CircularProgress
          size={16} // Adjusted size to be less intrusive, similar to text height
          sx={{
            color: colors.text.hint,
            position: 'relative',
            left: '4px',
          }}
        />
      ) : (
        <GradientTypography
          sx={{
            minWidth: '16px',
            textAlign: 'left',
          }}
        >
          {credits}
        </GradientTypography>
      )}
    </Button>
  );
}
